import { noop } from '../../../../lib/utilities';
import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import Notification from './tile/notification';
import FittingPromotion from './tile/notification/fitting_promotion';
import FreeShipping from './tile/notification/free_shipping';

import { ProductBadge } from './tile/product_badge';
import { ShowDetails } from './tile/show_details';
import { imageIsNonFallbackPlaceholder } from '../../helper/image_is_non_fallback_placeholder';
import { generateClassName } from '../../../_modules/helper/generate_class_name';
import { Price } from './tile/price';
import { Logo } from '../brand/logo';
import ShippingQuote from './tile/shipping_quote';
import { showAction } from '../../actions/catalog_postcode_actions';
import ErrorBoundary from '../../../_modules/error/error_boundary';
import { types as productTypes } from '../../../_constants/product/types';
import FittingStation from './tile/fitting_station';
import getTranslatedText from '../../helper/get_translated_text';
import isFSFDisabled from '../../helper/disable_fsf_for_store';
import Tooltip from '../tooltip/tooltip';
import ActiveStationsActions from '../../actions/active_station_actions';
import Translation from '../translation/translation';
import {
  clickOnAddToCartAdProduct,
  clickOnViewDetailsAdProduct,
} from '../../../_modules/google_analytics/product/product_tiles';
import DRRating from './tile/dr_rating';
import ProductEuLabels from './product_eu_labels';

const lazyContainerClassNames = generateClassName({
  'product-tile': true,
  'product-ad-tile': true,
  'product-tile--out-of-stock': ({ stock }) => !stock,
});

// const DRRating = React.lazy(() => import('./tile/dr_rating'));

const openPostcode = () => {
  return showAction();
};

function AdTile(props) {
  const {
    sku,
    dimensions,
    stock,
    url,
    productImage,
    manufacturer,
    hideManufacturerLogo,
    model,
    profileText,
    price,
    reviews,
    freeShipping,
    showFreeFitting,
    shippingTime,
    onNotifyMeClick,
    staticImagesUrl,
    priceRrp,
    showShowDetailsButton,
    hasImage,
    noImageUrl,
    priceRaw,
    fittingPromotion,
    onOpenFSFClick,
    onClickAddToCart,
    badges,
    customerAverageRatings,
    isNewProduct,
    labelFuelEfficiency,
    labelWetGrip,
    labelNoise,
    manufacturerImage,
  } = props.data;
  const { buyerAssistUrl } = props;

  let {
    bestseller,
    buy4for3,
    clearance,
    instantCash,
    newProduct,
    savePercent,
    tyroolasChoice,
    metroArea,
    productImageAltText,
    productType,
  } = props.data;
  bestseller = bestseller || false;
  buy4for3 = buy4for3 || false;
  clearance = clearance || false;
  instantCash = instantCash || false;
  newProduct = newProduct || false;
  savePercent = savePercent || false;
  tyroolasChoice = tyroolasChoice || false;
  metroArea = metroArea || '';
  productImageAltText = productImageAltText || manufacturer + ' ' + model + ' ' + dimensions;

  let fittingPromotionAvailable = false;
  if (
    null !== fittingPromotion &&
    'promotionName' in fittingPromotion &&
    (fittingPromotion.promotionName === 'next_day_fitting' ||
      fittingPromotion.promotionName === 'free_fitting' ||
      fittingPromotion.promotionName === 'free_mobile_fitting')
  ) {
    fittingPromotionAvailable = true;
  }

  const isNotOutOfStock = stock > 0;
  const productTypeIsTyreCar = productType === productTypes.TYRE_CAR;
  const productTypeIsTyreMoto = productType === productTypes.TYRE_MOTO;
  const isProductWheel = productType === productTypes.WHEEL;
  let { store } = TYROOLA.globals;
  const isShippingQuoteAllowed = ['AU', 'AU_SCA', 'AU_NRMA', 'NZ', 'NZ_SCA'].indexOf(store) >= 0;
  const shippingPostcode =
    props.shippingDataHasValue &&
    props.shippingData.length > 0 &&
    props.shippingData[0].statusCode === 200 &&
    props.shippingData[0].body.addressShipping
      ? props.shippingData[0].body.addressShipping.postcode
      : '';

  const isValidDRStore = TYROOLA.globals.store.driverReviewsEnabled;
  const adBtnProp = {
    tyreId: sku,
    baseUrl: '',
    productQuantity: stock < 4 ? stock : 4,
    fittingStationId: '',
    wheelAlignmentQuantity: 0,
    wheelAlignmentTwo: false,
    wheelAlignmentFour: false,
    manufacturer,
    model,
    dimensions,
    url,
  };
  const showDetails = true;

  let choiceAwardBadges = '';
  if (props.data.productBadges && props.data.productBadges.length) {
    choiceAwardBadges = [props.data.productBadges[0]].map((b) => (
      <img
        className="choice-award-badge product-tile__image product-tile__image-dr-badge"
        alt={'choice-award-badge'}
        src={b.imageUrl}
      />
    ));
  }

  return (
    <div className={lazyContainerClassNames({ stock })}>
      <div className="justify-content-space-between product-tile__parent-container">
        <div className="product-tile__product-desc">
          <a
            className="product-tile__product-link"
            href={url}
            onClick={() => props.onProductClick(sku)}
            style={{ position: 'relative' }}
          >
            <div className="product-tile__brand product-tile__brand--BF-GOODRICH">
              <Logo
                manufacturer={manufacturer}
                hideManufacturerLogo={hideManufacturerLogo}
                manufacturerImage={manufacturerImage}
              />
            </div>

            <h2 className="product-tile__model">
              {manufacturer} {model}
            </h2>

            <DRRating manufacturer={manufacturer} model={profileText} />

            <div>
              <Price
                price={price}
                badges={badges}
                priceRaw={priceRaw}
                priceRrp={priceRrp}
                currencyIsoCode={props.currencyIsoCode}
                onSeeHowItWorksClick={props.onSeeHowItWorksClick}
                buy4for3={buy4for3}
                priceDiscount={props.data.priceDiscount}
              />
            </div>
          </a>

          {buyerAssistUrl && (
            <a
              className="btn btn-primary btn-lg btn-round col-xs-12"
              href={buyerAssistUrl}
              rel="noreferrer"
              target="_blank"
            >
              {getTranslatedText('product-oscar-buyer-assist')}
            </a>
          )}

          <div className="product-tile__bottom-section">
            {fittingPromotion && fittingPromotion && !isFSFDisabled() ? (
              <FittingPromotion fittingPromotion={fittingPromotion} onOpenFSFClick={onOpenFSFClick} />
            ) : null}

            <FreeShipping
              metroArea={metroArea}
              staticImagesUrl={staticImagesUrl}
              postcode={shippingPostcode}
              freeShipping={freeShipping}
            />

            {isShippingQuoteAllowed && props.shippingDataHasValue && props.shippingFees}
            {isShippingQuoteAllowed && !props.shippingDataHasValue && stock > 0 && (
              <ShippingQuote openPostcode={openPostcode} httpRequestShippingFees={props.httpRequestShippingFees} />
            )}

            {productTypeIsTyreCar && isNotOutOfStock && !fittingPromotionAvailable && !isFSFDisabled() && (
              <FittingStation productSku={sku} staticImagesUrl={staticImagesUrl} onOpenFSFClick={onOpenFSFClick} />
            )}
          </div>
          <Notification
            stock={stock}
            fittingPromotion={fittingPromotion}
            shippingTime={shippingTime}
            onNotifyMeClick={onNotifyMeClick}
            sku={sku}
            price={price}
            productType={productType}
            productBatchStocks={props.productBatchStocks}
            httpRequestProductBatchStocks={props.httpRequestProductBatchStocks}
            onAlternativeProductStockClick={props.onAlternativeProductStockClick}
          />
          {stock > 0 && productTypeIsTyreCar && (
            <>
              <div className="add-to-cart sidebar__row-container--has-fitting">
                <Translation
                  tagName="a"
                  className="add-to-cart__button justify-content-center align-items-center"
                  style={{ marginTop: '10px', display: 'flex' }}
                  href={url}
                  onClick={() => props.onProductClick(sku)}
                  translationKey="product-mixed-order-form-show-details-cta"
                />
              </div>
            </>
          )}

          {stock > 0 && (isProductWheel || productTypeIsTyreMoto) && (
            <>
              <div className="add-to-cart sidebar__row-container--has-fitting">
                <Translation
                  tagName="a"
                  className="add-to-cart__button justify-content-center align-items-center"
                  style={{ marginTop: '10px', display: 'flex' }}
                  href={url}
                  onClick={() => props.onProductClick(sku)}
                  translationKey="product-mixed-order-form-show-details-cta"
                />
              </div>
            </>
          )}
        </div>

        <div className="display-flex" style={{ alignItems: 'end', position: 'relative' }}>
          <ProductBadge
            isRecommended={props.isRecommended}
            product={{
              badges: badges,
              bestseller: bestseller,
              buy4for3: buy4for3,
              clearance: clearance,
              instantCash: instantCash,
              newProduct: newProduct,
              savePercent: savePercent,
              tyroolasChoice: tyroolasChoice,
              manufacturer: manufacturer,
              isNewProduct,
            }}
          />

          <div>
            <div className="product-tile__product-image">
              <div className="lazyload-wrapper ">
                <a className="product-tile__product-link" href={url} onClick={() => props.onProductClick(sku)}>
                  <img
                    className="product-tile__image"
                    style={{ width: '100%' }}
                    alt={productImageAltText}
                    src={hasImage ? productImage : noImageUrl}
                  />
                </a>
              </div>
              {!hasImage && imageIsNonFallbackPlaceholder(noImageUrl) && (
                <Tooltip
                  label={getTranslatedText('product-image-illustration-only-label')}
                  content={getTranslatedText('product-image-illustration-only')}
                  additionalClassNames={['product-image-placeholder-text', 'dotted-underline']}
                />
              )}

              {choiceAwardBadges ? (
                <a style={{ position: 'relative' }} href={url} onClick={() => props.onProductClick(sku)}>
                  {choiceAwardBadges}
                </a>
              ) : (
                ''
              )}
            </div>
            <Translation tagName="span" className="product-tile__ad" translationKey="sponsored-product-tag-name" />
          </div>
        </div>
      </div>
    </div>
  );
}

function onViewDetailsClick(e, props) {
  clickOnViewDetailsAdProduct(props);
  window.location = props.url;
}

async function onAddToCartClick(e, props) {
  clickOnAddToCartAdProduct(props);
  await _prepareCartRequest(props);
  window.location = `${location.origin}${TYROOLA.globals.baseUrl}/cart/`;
}

function _prepareCartRequest(props) {
  return ActiveStationsActions.addProductToCartAction(
    { id: props.fittingStationId, qty: props.productQuantity },
    props.tyreId,
    false,
    true,
    0,
    0,
  );
}

AdTile.propTypes = {
  data: PropTypes.shape({
    stock: PropTypes.number.isRequired,
    priceRaw: PropTypes.number.isRequired,
    sku: PropTypes.string.isRequired,
    dimensions: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    productImage: PropTypes.string.isRequired,
    noImageUrl: PropTypes.string.isRequired,
    manufacturer: PropTypes.string.isRequired,
    manufacturerImage: PropTypes.string.isRequired,
    model: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    shippingTime: PropTypes.string.isRequired,
    staticImagesUrl: PropTypes.string.isRequired,
    hasImage: PropTypes.bool.isRequired,
    hideManufacturerLogo: PropTypes.bool.isRequired,
    showFreeFitting: PropTypes.bool.isRequired,
    reviews: PropTypes.object.isRequired,
    onNotifyMeClick: PropTypes.func.isRequired,
    onOpenFSFClick: PropTypes.func.isRequired,
    onClickAddToCart: PropTypes.func.isRequired,
    priceRrp: PropTypes.string,
    metroArea: PropTypes.string,
    bestseller: PropTypes.bool,
    buy4for3: PropTypes.bool,
    clearance: PropTypes.bool,
    instantCash: PropTypes.bool,
    newProduct: PropTypes.bool,
    savePercent: PropTypes.bool,
    tyroolasChoice: PropTypes.bool,
    showShowDetailsButton: PropTypes.bool,
    productType: PropTypes.string,
  }).isRequired,
  buyerAssistUrl: PropTypes.string,
  shippingData: PropTypes.array,
  shippingDataHasValue: PropTypes.bool.isRequired,
  shippingFees: PropTypes.object.isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
  onSeeHowItWorksClick: PropTypes.func.isRequired,
  onProductClick: PropTypes.func,
  httpRequestShippingFees: PropTypes.object.isRequired,
  productBatchStocks: PropTypes.object,
  httpRequestProductBatchStocks: PropTypes.object.isRequired,
  onAlternativeProductStockClick: PropTypes.func.isRequired,
};

AdTile.defaultProps = {
  onProductClick: noop,
  shippingData: [],
  productBatchStocks: [],
};

export default AdTile;
